import moment from 'moment'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignUpdatedTooltip = ({ template }) => {
  const tooltipId = `template-updated-${template.id}`
  const updatedByName = template.updatedByName || 'Unknown author'
  const relativeUpdate = template.updatedOn ? moment(template.updatedOn).fromNow() : null
  const absoluteUpdate = template.updatedOn
    ? moment(template.updatedOn).format('MMM D, YYYY [at] h:mm A')
    : null
  const summary =
    template.updatedDescription ||
    (relativeUpdate ? `Updated ${relativeUpdate}` : 'Never updated')

  return (
    <span className={styles.updatedTooltipHost}>
      <span
        className={styles.templateAvatar}
        tabIndex={0}
        aria-describedby={tooltipId}
        aria-label={`${summary} by ${updatedByName}`}
      >
        {template.updatedByInitials || '—'}
      </span>
      <span className={styles.updatedTooltip} id={tooltipId} role="tooltip">
        <span className={styles.updatedTooltipTitle}>{updatedByName}</span>
        <span className={styles.updatedTooltipText}>{summary}</span>
        {absoluteUpdate && (
          <span className={styles.updatedTooltipMeta}>{absoluteUpdate}</span>
        )}
      </span>
    </span>
  )
}

export default InviteEmailDesignUpdatedTooltip
